function transformerData(data, transformers, callback){
    // concatFunc(data, transformers, callback);
    let result = data;
    for (let i = 0; i < transformers.length; i++) {
        const transformer = transformers[i];
        if(typeof transformer.func=== 'function'){
            result = transformer.func(result, transformer.params, transformers[i+1])
        }
    }
    return result;
}

function concatFunc(orginValue, funcConfigs, callback) {
    var len = funcConfigs.length;
    let preValue = orginValue;
    for (let i = 0; i < funcConfigs.length; i++) {
        const config = funcConfigs[i];
        let nextFunc = createNextFunc(i+1);
        config.func.call(this, preValue, config.params, nextFunc);
    }
    // callback.call(this, preValue);

    function createNextFunc(index) {
        return function(value){
            if(index<len){
                let config = funcConfigs[index];
                return config.func.call(this, value, config.params, createNextFunc(index+1));
            }else{
                return callback.call(this, value);
            }
        }
    }
}

export {transformerData, concatFunc}